var React = require('react');

function Bardziej (props) {
    return React.createElement("svg",props,React.createElement("polygon",{"className":"st0","points":"0,0 0,24 42.2,43.7 42.4,43.8 42.2,43.8 0,63.5 0,87.5 62.8,58.2 62.8,29.3 0,0 "}));
}

Bardziej.defaultProps = {"version":"1.1","id":"Warstwa_1","x":"0px","y":"0px","viewBox":"0 0 62.8 87.5","style":{"enableBackground":"new 0 0 62.8 87.5"},"xmlSpace":"preserve"};

module.exports = Bardziej;

Bardziej.default = Bardziej;
